import * as Panels from '../../util/panels';
import React from 'react';
import {CodeComparerConfig} from './common';
import * as Query from '../../util/queryts';
import {toRunsDataQuery} from '../../containers/RunsDataLoader';

const PANEL_TYPE = 'Code Comparer';

const codeComparerTransformQuery = (query: Query.Query) => {
  const transformed = toRunsDataQuery(
    query,
    {selectionsAsFilters: true},
    {wandbKeys: ['code_path', 'session_history']}
  );
  return transformed;
};

export const Spec: Panels.PanelSpec<typeof PANEL_TYPE, CodeComparerConfig> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery: codeComparerTransformQuery,
  noEditMode: true,

  exportable: {
    api: true,
  },

  icon: 'panel-html',
};
